let global = {
  isAbortingRequest: false,
  menu: []
}

export default global

